import {
  GET_COUNTRIES,
  GET_COUNTRIES_SUCCESS,
  GET_COUNTRIES_FAILED,
  GET_STATES,
  GET_STATES_SUCCESS,
  GET_STATES_FAILED,
  GET_CITIES,
  GET_CITIES_SUCCESS,
  GET_CITIES_FAILED,
  GET_CITIES_BY_STATE_ID,
  GET_CITIES_BY_STATE_ID_SUCCESS,
  GET_CITIES_BY_STATE_ID_FAILED,
} from './constants';

const initialState = {
  countries: [],
  states: [],
  cities: [],
  error: null,
  loading: false,
  loadingStates: false,
  loadingCities: false,
};

const locationReducer = (state = initialState, action = null) => {
  switch (action.type) {
    case GET_STATES:
      return { ...state, loading: true, loadingStates: true };
    case GET_STATES_SUCCESS:
      return { ...state, states: action.payload.states, loading: false, loadingStates: false };
    case GET_STATES_FAILED:
      return { ...state, error: action.payload.error, loading: false, loadingStates: false };
    case GET_CITIES:
      return { ...state, loading: true, loadingCities: true };
    case GET_CITIES_SUCCESS:
      return { ...state, cities: action.payload.cities, loading: false, loadingCities: false };
    case GET_CITIES_FAILED:
      return { ...state, error: action.payload.error, loading: false, loadingCities: false };
    case GET_CITIES_BY_STATE_ID:
      return { ...state, loading: true, loadingCities: true };
    case GET_CITIES_BY_STATE_ID_SUCCESS:
      return { ...state, cities: action.payload.cities, loading: false, loadingCities: false };
    case GET_CITIES_BY_STATE_ID_FAILED:
      return { ...state, error: action.payload.error, loading: false, loadingCities: false };
    default:
      return state;
  }
};

export default locationReducer;
